import React from 'react';
import RealEstateResult from './RealEstateResult';
const ProjectResult = ({ hit }) => {
    return (React.createElement(RealEstateResult, { hit: hit, imageUrl: hit._source.fields.thumbnail, title: hit._source.title, content: hit._source.content }));
};
export default ProjectResult;
